import { render, staticRenderFns } from "./RegionRoute.vue?vue&type=template&id=6b4ba902&"
import script from "./RegionRoute.vue?vue&type=script&lang=js&"
export * from "./RegionRoute.vue?vue&type=script&lang=js&"
import style0 from "./RegionRoute.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports